<template>
  <div
    :class="{ 'mdc-text-field--disabled mdc-text-field--upgraded': disabled }"
    class="mdc-text-field mdc-text-field--textarea"
  >
    <textarea
      :id="_uid"
      :value="value"
      class="mdc-text-field__input"
      rows="6"
      @blur="$emit('blur', $event)"
      @input="$emit('input', $event.target.value)"
    />
    <div class="mdc-notched-outline">
      <div class="mdc-notched-outline__leading"></div>
      <div class="mdc-notched-outline__notch">
        <label
          :for="_uid"
          :disabled="disabled"
          class="mdc-floating-label"
          v-text="label"
        />
      </div>
      <div class="mdc-notched-outline__trailing"></div>
    </div>
  </div>
</template>

<script>
import { MDCTextField } from '@material/textfield';

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    mdcTextField: null,
  }),
  mounted() {
    this.mdcTextField = new MDCTextField(this.$el);
  },
  beforeDestroy() {
    this.mdcTextField.destroy();
  },
};
</script>
